import { createSelector } from '@reduxjs/toolkit'

const sliceSelector = (state) => state.membershipsPicker

export const entitiesSelector = createSelector(
  sliceSelector,
  ({ entities }) => entities
)

export const initializingSelector = createSelector(
  sliceSelector,
  ({ initializing }) => initializing
)

export const searchingSelector = createSelector(
  sliceSelector,
  ({ searching }) => searching
)

export const suggestionsSelector = createSelector(
  sliceSelector,
  ({ suggestions }) => suggestions
)
export const selectedSuggestionsSelector = createSelector(
  sliceSelector,
  ({ selectedSuggestions }) => selectedSuggestions
)

export const orgAdminsToRemoveSelector = createSelector(
  sliceSelector,
  ({ orgAdminsToRemove }) => orgAdminsToRemove
)

export const selectedMembershipIdsSelector = createSelector(
  selectedSuggestionsSelector,
  (suggestions) => suggestions.filter(({ type }) => type === 'organization_membership').map(({ entity }) => entity.id)
)

export const selectedInvitationIdsSelector = createSelector(
  selectedSuggestionsSelector,
  (suggestions) => suggestions.filter(({ type }) => type === 'organization_invitation').map(({ entity }) => entity.id)
)

export const selectedUserGroupIdsSelector = createSelector(
  selectedSuggestionsSelector,
  (suggestions) => suggestions.filter(({ type }) => type === 'user_group').map(({ entity }) => entity.id)
)

export const selectedMigrationsSelector = createSelector(
  selectedSuggestionsSelector,
  (suggestions) => suggestions.filter(({ type }) => type === 'user_consolidation').map(({ entity }) => entity.id)
)
